import { AfterViewChecked, AfterViewInit, Directive, ElementRef, isDevMode, OnInit, Optional } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';

const A11Y_LABEL_SPAN_CLASS = 'a11y-label-span';

@Directive({
  selector: 'mat-select[placeholder]'
})
export class FindInvalidSelectPlaceholderDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    if (isDevMode() && this.hasNotMatLabel(this.elementRef)) {
      this.elementRef.nativeElement.style.backgroundColor = 'orange';
      console.error('Use <mat-label> instead of placeholder property on mat-select', this.elementRef);
    }
  }

  private hasNotMatLabel(element: ElementRef<HTMLElement>): boolean {
    return !element.nativeElement.parentNode.querySelector('mat-label');
  }
}

// @Directive({
// // tslint:disable-next-line: directive-selector
//   selector: 'mat-label, mat-placeholder'
// })
// export class SelectA11yFixDirective implements OnInit, AfterViewChecked {
//
//   private enabled: boolean = false;
//
//   constructor(private elementRef: ElementRef<HTMLElement>,
//               private translateService: TranslateService,
//               @Optional() private matFormField: MatFormField) {
//   }
//
//   ngOnInit() {
//     this.enabled = this.matFormField && this.matFormField._control instanceof MatSelect;
//   }
//
//   ngAfterViewChecked(): void {
//     if (!this.enabled) {
//       return;
//     }
//
//     const found: Element = Array.from(this.elementRef.nativeElement.children).find(child => child.classList.contains(A11Y_LABEL_SPAN_CLASS));
//
//     if (found) {
//       found.remove();
//     }
//
//     const text = this.translateService.instant('GENERAL.CHOSEN_OPTION', { text: this.getDisplayText(this.matFormField) });
//     const spanElement = document.createElement('span');
//     spanElement.classList.add(A11Y_LABEL_SPAN_CLASS);
//     spanElement.classList.add('aria-hide');
//     spanElement.innerText = text;
//
//     this.elementRef.nativeElement.appendChild(spanElement);
//   }
//
//   getDisplayText(matFormField: MatFormField): string {
//     const control = matFormField._control as MatSelect;
//
//     const option = control.options.find(item => item.selected);
//
//     return option && option.viewValue;
//   }
//
// }
